<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <div :style="C_timerStyle" v-show="C_isVisible">
      {{DV_currentTime}}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"
import moment from 'moment';

export default {
  props: [
    'P_format', 
    'P_fontSize',
    'P_fontColor',
    'P_fontWeight',
    'P_background',
    'P_customCss'
  ],
  mixins: [bi10GridComponent],
  data() {
    return {
      DV_currentTime: moment().format(this.P_format),
      interval: null
    }
  },
  computed: {
    C_timerStyle() {
      let customStyle = {'textAlign': 'center'}

      if (this.P_fontWeight) customStyle["fontWeight"] = this.P_fontWeight
      if (this.P_fontSize) customStyle["fontSize"] = this.P_fontSize
      if (this.P_fontColor) customStyle["color"] = this.P_fontColor
      if (this.P_background) customStyle["backgroundColor"] = this.P_background

      return customStyle;
    }
  },
  mounted() {
    setInterval(this.tick, 1000);
  },
  methods: {
    tick() {
      this.DV_currentTime = moment().format(this.P_format);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Grid/GDateTime.vue